function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import CropperElement from '@cropper/element';
import { CROPPER_SHADE, CROPPER_CANVAS, CROPPER_SELECTION, ACTION_SELECT, on, EVENT_ACTION_START, EVENT_ACTION_END, EVENT_CHANGE, off, isNumber, WINDOW } from '@cropper/utils';
var style = ":host{display:block;height:0;left:0;outline:var(--theme-color) solid 1px;position:relative;top:0;width:0}:host([transparent]){outline-color:transparent}";
var canvasCache = new WeakMap();

var CropperShade = /*#__PURE__*/function (_CropperElement) {
  _inherits(CropperShade, _CropperElement);

  var _super = _createSuper(CropperShade);

  function CropperShade() {
    var _this;

    _classCallCheck(this, CropperShade);

    _this = _super.apply(this, arguments);
    _this.$onCanvasActionEnd = null;
    _this.$onCanvasActionStart = null;
    _this.$onSelectionChange = null;
    _this.$style = style;
    _this.x = 0;
    _this.y = 0;
    _this.width = 0;
    _this.height = 0;
    _this.slottable = false;
    _this.themeColor = 'rgba(0, 0, 0, 0.65)';
    return _this;
  }

  _createClass(CropperShade, [{
    key: "$canvas",
    get: function get() {
      return canvasCache.get(this);
    },
    set: function set(element) {
      canvasCache.set(this, element);
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this2 = this;

      _get(_getPrototypeOf(CropperShade.prototype), "connectedCallback", this).call(this);

      var $canvas = this.closest(this.$getTagNameOf(CROPPER_CANVAS));

      if ($canvas) {
        this.$canvas = $canvas;
        this.style.position = 'absolute';
        var $selection = $canvas.querySelector(this.$getTagNameOf(CROPPER_SELECTION));

        if ($selection) {
          this.$onCanvasActionStart = function (event) {
            if ($selection.hidden && event.detail.action === ACTION_SELECT) {
              _this2.hidden = false;
            }
          };

          this.$onCanvasActionEnd = function (event) {
            if ($selection.hidden && event.detail.action === ACTION_SELECT) {
              _this2.hidden = true;
            }
          };

          this.$onSelectionChange = function (event) {
            var _ref = event.defaultPrevented ? $selection : event.detail,
                x = _ref.x,
                y = _ref.y,
                width = _ref.width,
                height = _ref.height;

            _this2.$change(x, y, width, height);

            if ($selection.hidden || x === 0 && y === 0 && width === 0 && height === 0) {
              _this2.hidden = true;
            }
          };

          on($canvas, EVENT_ACTION_START, this.$onCanvasActionStart);
          on($canvas, EVENT_ACTION_END, this.$onCanvasActionEnd);
          on($canvas, EVENT_CHANGE, this.$onSelectionChange);
        }
      }

      this.$render();
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      var $canvas = this.$canvas;

      if ($canvas) {
        if (this.$onCanvasActionStart) {
          off($canvas, EVENT_ACTION_START, this.$onCanvasActionStart);
          this.$onCanvasActionStart = null;
        }

        if (this.$onCanvasActionEnd) {
          off($canvas, EVENT_ACTION_END, this.$onCanvasActionEnd);
          this.$onCanvasActionEnd = null;
        }

        if (this.$onSelectionChange) {
          off($canvas, EVENT_CHANGE, this.$onSelectionChange);
          this.$onSelectionChange = null;
        }
      }

      _get(_getPrototypeOf(CropperShade.prototype), "disconnectedCallback", this).call(this);
    }
    /**
     * Changes the position and/or size of the shade.
     * @param {number} x The new position in the horizontal direction.
     * @param {number} y The new position in the vertical direction.
     * @param {number} [width] The new width.
     * @param {number} [height] The new height.
     * @returns {CropperShade} Returns `this` for chaining.
     */

  }, {
    key: "$change",
    value: function $change(x, y) {
      var width = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.width;
      var height = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : this.height;

      if (!isNumber(x) || !isNumber(y) || !isNumber(width) || !isNumber(height) || x === this.x && y === this.y && width === this.width && height === this.height) {
        return this;
      }

      if (this.hidden) {
        this.hidden = false;
      }

      this.x = x;
      this.y = y;
      this.width = width;
      this.height = height;
      return this.$render();
    }
    /**
     * Resets the shade to its initial position and size.
     * @returns {CropperShade} Returns `this` for chaining.
     */

  }, {
    key: "$reset",
    value: function $reset() {
      return this.$change(0, 0, 0, 0);
    }
    /**
     * Refreshes the position or size of the shade.
     * @returns {CropperShade} Returns `this` for chaining.
     */

  }, {
    key: "$render",
    value: function $render() {
      return this.$setStyles({
        transform: "translate(".concat(this.x, "px, ").concat(this.y, "px)"),
        width: this.width,
        height: this.height,
        outlineWidth: WINDOW.innerWidth
      });
    }
  }], [{
    key: "observedAttributes",
    get: function get() {
      return _get(_getPrototypeOf(CropperShade), "observedAttributes", this).concat(['height', 'width', 'x', 'y']);
    }
  }]);

  return CropperShade;
}(CropperElement);

CropperShade.$name = CROPPER_SHADE;
CropperShade.$version = '2.1.0';
export { CropperShade as default };